module.exports = __webpack_require__.p + "2b01e27339bacadf099abfe0e87f973e.jpg";